<template>
  <div class="iasi">
    <h1>Iaşi, Jassy</h1>
      <article>
        Doriţi o prelungare? Faceţi un click pe o posa!
        Posele marcat cu "nn" nu sânt de la mine.<br/>
          Klicken Sie auf ein Foto, 
          um eine Vergrößerung zu erhalten<br>
          Mit (nn) markierte Fotos stammen nicht von mir.
      </article>
      <article class="fotos">
        <div class="foto">
          <img src="../assets/fotos/iasi_1kl.jpg" width="150" border="0" height="110" alt="Iaşi, Jassy (Foto M. Gnierim)" 
          @click="callImageClick('Iaşi, Jassy (Foto M. Gnierim)', 'iasi_1.jpg', $event)">
          <br>Iaşi, Jassy (Foto M. Gnierim)
        </div>
        <div class="foto">
          <img src="../assets/fotos/iasi_2kl.jpg" width="125" border="0" height="110" alt="Iaşi, Jassy" 
          @click="callImageClick('Iaşi, Jassy', 'iasi_2.jpg', $event)">
          <br>Iaşi, Jassy
        </div>
      </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>